import React from 'react'
import { Table, Typography } from 'antd';

const { Text } = Typography

const columns = [
  // {
  //   title: "",
  //   dataIndex: "id",
  // },
  {
    title: '',
    children: [
      {
        title: "Days",
        dataIndex: "days",
      },
      {
        title: "Date",
        dataIndex: "date",
      },
      {
        title: "Paid Date",
        dataIndex: "paidDate",
      },
    ]
  },
  {
    title: 'Loan Amount and Balance',
    children: [
      {
        title: "Principal Due",
        dataIndex: "principalDue",
      },
      {
        title: "Balance Of Loan",
        dataIndex: "balanceOfLoan",
      },
    ]
  },
  {
    title: 'Total Cost of Loan',
    children: [
      {
        title: "Interest",
        dataIndex: "interest",
      },
      {
        title: "Fees",
        dataIndex: "fees",
      },
      {
        title: "Penalties",
        dataIndex: "penalties",
      },
    ]
  },

  {
    title: 'Installment Totals',
    children: [
      {
        title: "Due",
        dataIndex: "due",
      },
      {
        title: "Paid",
        dataIndex: "paid",
      },
      {
        title: "In Advance",
        dataIndex: "inAdvance",
      },
      {
        title: "Late",
        dataIndex: "late",
      },
      {
        title: "Oustanding",
        dataIndex: "outstanding",
      },
    ]
  },
 
  
];


const RepaymentSchedule = (props) => {

  const { repaymentScheduleList, accountDetails } = props;
  // const { styles } = useStyle();

  return (
    <>
      <Table
        columns={columns}
        dataSource={repaymentScheduleList}
        summary={(pageData) => {
          return (
            <>
              <Table.Summary.Row >
                <Table.Summary.Cell index={0}><Text style={{ fontWeight: "bolder" }}>Total</Text></Table.Summary.Cell>
                {/* <Table.Summary.Cell index={1}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.loanTermInDays}</Text>
                </Table.Summary.Cell> */}
                <Table.Summary.Cell index={2}>
                  <Text style={{ fontWeight: "bolder" }}>{"-"}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <Text style={{ fontWeight: "bolder" }}>{"-"}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalPrincipalExpected}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}>
                  <Text style={{ fontWeight: "bolder" }}>{"-"}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalInterestCharged}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalFeeChargesCharged}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalPenaltyChargesCharged}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={9}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalRepaymentExpected}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={10}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalRepayment}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={11}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalPaidInAdvance}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={12}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalPaidLate}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={13}>
                  <Text style={{ fontWeight: "bolder" }}>{accountDetails?.repaymentSchedule?.totalOutstanding}</Text>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      />
    </>
  )
}

export default RepaymentSchedule